import { useAtom } from '@reatom/npm-react'
import React from 'react'

import { UserShortAvatar } from '@root/entities/user-short/ui/user-short-avatar'

import { userAtom } from '../atoms'

import type { ClassNameProps } from '@root/shared/react'
import type { AvatarProps } from '@root/shared/ui-kit'

type UserAvatarProps = Pick<AvatarProps, 'size'> &
  ClassNameProps & {
    onClick?: () => void
    withHypedLetter?: boolean
    outlineWidth?: number
    outlineSpacingWidth?: number
    isOnline?: boolean
    withPreview?: boolean
  }

export const UserAvatar: React.FC<UserAvatarProps> = React.memo(
  ({
    withHypedLetter = false,
    outlineWidth = 1,
    outlineSpacingWidth = 1,
    isOnline = false,
    ...props
  }) => {
    const [user] = useAtom(userAtom)

    return (
      <UserShortAvatar
        userShort={user}
        withHypedLetter={withHypedLetter}
        outlineWidth={outlineWidth}
        outlineSpacingWidth={outlineSpacingWidth}
        isOnline={isOnline}
        {...props}
      />
    )
  },
)
UserAvatar.displayName = 'UserAvatar'
